import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { GetterService } from '../service/getter-service.service';
import { RequestService } from '../service/request.service';

@Injectable({
  providedIn: 'root',
})
export class payGuard implements CanActivate {
  constructor(
    private _local: GetterService,
    private _router: Router,
    private _requestService: RequestService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (
      this._requestService.isLoggedIn() ||
      this._local.getSessionItem('access_token')
    ) {
      return true;
    } else {
      this._router.navigate([this._requestService.setUrl('login')]);
      return false;
    }
  }
}
